import styled from "styled-components";

export const Carrd = styled.div`
  width: ${({ width }) => (width ? `${width}px` : "345px")};
  height: 336px;
  background-image: ${({ backImg }) => `url("${backImg}")`};
  background-size: cover;
  border-radius: 3px;
  display: flex;
  flex-direction: column;
  color: black;
  margin: 0 15px;
  cursor: pointer;
  :hover {
    box-shadow: 0px 10px 50px rgba(13, 38, 59, 0.1);
    .icon {
      background-color: var(--colorBlue);
      path {
        fill: #ffffff !important;
      }
    }
  }
`;
